import { FC, useMemo } from 'react';
import { Image, StyleSheet, View } from 'react-native';
import { COLORS, FONTS } from '../../../constants';
import { Text } from '../../../components/Text';
import { Button } from '../../../components/Button';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { NavigationService } from '../../../services/navigation';
import { useSelector } from 'react-redux';
import { RootState } from '../../../services/redux';
import { IActivity } from '../../../types/activities.types';
import { isSameDate } from '../../../services/utils/dateConvert';
import dayjs from 'dayjs';
import { DATE_TYPE } from '../../../constants/activity';
import { convertToAmPm } from '../../../services/utils';

interface BookActivitySuccessProps {
  activity: IActivity;
}

export const BookActivitySuccess: FC<BookActivitySuccessProps> = ({
  activity,
}) => {
  const isDesktop = useIsDesktop();
  const { user } = useSelector((redux: RootState) => redux.authReducer);

  const renderActivityData = useMemo(() => {
    const dateData =
      activity.date_type.value === DATE_TYPE.NORMAL
        ? activity.start_date === activity.end_date
          ? [
              {
                name: 'Activity Date',
                value: dayjs(new Date(activity.start_date)).format(
                  'D MMMM YYYY'
                ),
              },
            ]
          : [
              {
                name: 'Start Date',
                value: dayjs(new Date(activity.start_date)).format(
                  'D MMMM YYYY'
                ),
              },
              {
                name: 'End Date',
                value: dayjs(new Date(activity.end_date)).format('D MMMM YYYY'),
              },
            ]
        : [
            {
              name: 'Activity Date',
              value: activity.date_type.name,
            },
          ];

    const data = [
      ...[
        {
          name: 'Activity Name',
          value: activity.name,
        },
      ],
      ...dateData,
      ...[
        {
          name: 'Activity Time',
          value: `${convertToAmPm(activity.start_time)} - ${convertToAmPm(
            activity.end_time
          )}`,
        },
        {
          name: 'Support Type',
          value: user?.type_name,
        },
        {
          name: 'Booking Status',
          value: 'Pending Confirmation',
        },
      ],
    ];

    return (
      <View
        style={{
          flexDirection: 'column',
        }}
      >
        {data.map((item) => (
          <View style={{ flexDirection: 'row' }}>
            <Text
              style={[
                {
                  width: isDesktop() ? '20%' : '43%',
                },
                styles.text,
              ]}
            >{`${item.name}:`}</Text>
            <Text style={[{ flex: 1 }, styles.text]}>{item.value}</Text>
          </View>
        ))}
      </View>
    );
  }, [user?.type_name, isDesktop, activity]);

  return (
    <View
      style={{
        flexDirection: 'column',
        backgroundColor: COLORS.LIGHT_RED,
        borderRadius: 18,
        shadowColor: '#F0F0F0',
        shadowOffset: { width: 0, height: 12 },
        shadowOpacity: 1,
        shadowRadius: 32,
        elevation: 20,
        paddingTop: 60,
        paddingHorizontal: 20,
      }}
    >
      <Image
        source={require('../../../assets/checked-icon.png')}
        style={{ width: 90, height: 90, alignSelf: 'center', marginBottom: 40 }}
      />
      {/* {isDesktop() ? ( */}
      <View>
        <Text
          style={[
            {
              fontFamily: FONTS.AvenirRegular,
              fontWeight: '800',
              letterSpacing: 1.1,
              textAlign: 'center',
              marginBottom: 20,
            },
            isDesktop()
              ? {
                  fontSize: 26,
                  lineHeight: 40,
                  paddingHorizontal: 70,
                }
              : {
                  fontSize: 22,
                  lineHeight: 37,
                },
          ]}
        >
          {`Thank You For Registering As An ${user?.type_name} For This Activity!`}
        </Text>
        <View style={{ marginBottom: 25, paddingHorizontal: 15 }}>
          {renderActivityData}
        </View>
        <Text
          style={[
            styles.text,
            { marginBottom: 55 },
            !isDesktop() && { textAlign: 'center' },
          ]}
        >
          {`Thank you for booking this Helping Hand activity as an ${user?.type_name}. We appreciate your support. We will confirm your booking as soon as possible. We will send you an email notification once the booking is confirmed.`}
        </Text>
      </View>
      {/* ) : (
        <View>
          <Text
            style={{
              fontFamily: FONTS.AvenirMedium,
              fontWeight: '800',
              fontSize: 20,
              lineHeight: 31,
              letterSpacing: 1.1,
              textAlign: 'center',
              marginBottom: 25,
            }}
          >
            {`Thank You for Booking!`}
          </Text>
          <Text
            style={[styles.text, { textAlign: 'center', marginBottom: 20 }]}
          >
            Thank you for booking your activity with Helping Hand. Our team will
            review your booking and confirm it as soon as possible. Once
            confirmed, you’ll get an email notification.
          </Text>
          <Text
            style={[styles.text, { textAlign: 'center', marginBottom: 40 }]}
          >
            If you have any questions, feel free to contact us at (852) 2522
            4494 or admin@helpinghand.org.hk.
          </Text>
        </View>
      )} */}

      <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
        <Button
          onPress={() => {
            NavigationService.push('Root', {
              screen: 'HomeTab',
            });
          }}
          desktopButtonStyle={{
            borderRadius: 16,
            marginBottom: 80,
          }}
          textStyle={{
            fontWeight: '500',
            fontSize: 19,
            fontFamily: FONTS.AvenirMedium,
            lineHeight: 30,
            letterSpacing: 1.2,
          }}
          style={[
            {
              width: isDesktop() ? 320 : '100%',
              paddingVertical: 23,
              borderRadius: 16,
            },
            !isDesktop() && {
              marginBottom: 20,
            },
          ]}
          text="CONTINUE TO HOME"
          arrowRight={false}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  text: {
    fontFamily: FONTS.AvenirMedium,
    fontWeight: '500',
    fontSize: 16,
    lineHeight: 30,
    color: COLORS.GREY,
  },
});
